<template>
  <div class="general_section">
    <Colors></Colors>
    <Sizes></Sizes>
  </div>
</template>

<script>
import Colors from "./Colors.vue"
import Sizes from "./Sizes.vue"

export default {
  components: {
    Colors,
    Sizes
  },
}

</script>
<style scoped>
.general_section{
  display: grid !important;
  grid-template-columns: 1fr !important;
  grid-gap: 20px !important;
}
</style>
